import { StyledTableHead, StyledTableHeadCell } from '../../../styles/TableStyles'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Box, TableRow } from '@mui/material'

type WeeklyCalendarHeaderProps = {
  selectedDate: string
}

const WeeklyCalendarHeader = ({ selectedDate }: WeeklyCalendarHeaderProps) => {
  const [weekDays, setWeekDays] = useState<string[]>([])
  const storedLanguage = localStorage.getItem('language')
  useEffect(() => {
    const monday = dayjs(selectedDate).startOf('week')

    const weekDaysArray = Array.from({ length: 7 }, (_, i) => {
      const date = monday.add(i, 'day')
      const dayName = date.format('dddd')
      const formattedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1)

      return `${formattedDayName} ${date.format('D')}`
    })

    setWeekDays(weekDaysArray)
  }, [selectedDate, storedLanguage])

  const shortTimezone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]

  return (
    <StyledTableHead
      sx={{
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 5,
        borderRadius: '8px !important',
      }}
    >
      <TableRow>
        <StyledTableHeadCell
          align="center"
          sx={{
            top: '0px',
            width: '60px !important',
            minWidth: '60px !important',
            position: 'sticky',
            left: 0,
            backgroundColor: 'background.elevation1',
            borderRadius: '8px 0px 0px 0px !important',
            padding: '0px 0px',
          }}
        >
          <Box
            sx={{
              height: '34.29px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'background.elevation9',
              borderRadius: '8px 0px 0px 8px !important',
            }}
          >
            {shortTimezone}
          </Box>
        </StyledTableHeadCell>
        {Array.from({ length: 7 }, (_, i) => (
          <StyledTableHeadCell
            key={i}
            align="center"
            sx={{
              flex: 1,
              minWidth: '120px',
              top: '0px',
            }}
          >
            {weekDays[i]}
          </StyledTableHeadCell>
        ))}
      </TableRow>
    </StyledTableHead>
  )
}

export default WeeklyCalendarHeader